import{jsx as t,Fragment as i}from"react/jsx-runtime";import{styled as o}from"styled-components";import{GLOBAL_AREA as n}from"../constants/ElementId.mjs";const r=o.div`
  color: #f0f0f0;
  margin: 0px;
  padding: 0px;
  height: 38px;
  overflow: hidden;
  margin-bottom: 6px;
  max-width: 1200px;

  input.help {
    min-width: 120px;
  }
  .tipped {
    color: #bbbbbb;
  }
`;function e({children:o}){return t(i,{children:t(r,{id:n,children:o})})}export{e as GlobalAreaContainer};
